import { Helmet } from "react-helmet-async";
import Brands from "src/sections/overview/dashboards/views/brand-pulse/brands";

export default function LeaderboardTrackedCompetitors() {
    return (
        <>
            <Helmet>
                <title>Tracked Competitors</title>
            </Helmet>

            <Brands />
        </>
    );
}
